import React from "react";
import PastEventsTab from "./PastEventsTab";
import UpcomingEventsTab from "./UpcomingEventsTab";
import "./EventEngagementWidget.css";
import { Link } from "react-router-dom";
import Card from "../../../theme/untitled/Card/Card";
import Tabs from "../../../theme/untitled/Tabs/Tabs";
import Icon from "../../../theme/untitled/icons/Icon";

const TABS = [
  { key: "upcoming", label: "Upcoming" },
  { key: "past", label: "Past events" },
];

/**
 * @typedef {Object} EventSource
 * @property {number} widget
 * @property {number} direct
 * @property {number} qr
 * @property {number} email
 */

/**
 * @typedef {Object} EventStat
 * @property {string} event_uuid
 * @property {string} name
 * @property {string} date          - ISO date string
 * @property {number} impressions
 * @property {number} views
 * @property {EventSource} sources
 */

/**
 * @param {Object}      props
 * @param {EventStat[]} props.pastEvents
 * @param {EventStat[]} props.upcomingEvents
 * @param {number}      [props.range]
 * @param {string}      [props.activeTab]
 * @param {Boolean}      [props.isLoading]
 * @param {Function}    props.onRangeChange - (days: number) => void
 * @param {Function}    props.onActiveTabChange - (days: number) => void
 * @param {Function}    [props.onViewAll]     - () => void
 */
export default function EventEngagementWidget({
  pastEvents = [],
  upcomingEvents = [],
  range = 7,
  onRangeChange,
  onViewAll,
  activeTab = "past",
  onActiveTabChange,
  isLoading = true,
}) {
  return (
    <Card>
      <Card.Header
        title="Event engagement"
        subtitle={`Impressions and views, last ${range} days.`}
      >
        <Link to={"/reports/event-engagement"} className="eew-view-all">
          View all
          <Icon name="ArrowNarrowRight" size={16} />
        </Link>
      </Card.Header>
      <Card.Body noPadding>
        <div className="eew-toolbar">
          <Tabs
            items={TABS}
            value={activeTab}
            onChange={(tab) => onActiveTabChange(tab)()}
          />
        </div>
        {activeTab === "past" ? (
          <PastEventsTab
            events={pastEvents}
            range={range}
            onRangeChange={onRangeChange}
            isLoading={isLoading}
          />
        ) : (
          <UpcomingEventsTab
            events={upcomingEvents}
            range={range}
            onRangeChange={onRangeChange}
            isLoading={isLoading}
          />
        )}
      </Card.Body>
    </Card>
  );
}
